@let integrationName = integration().name;
@let apiKeyName = i18nPrefix + ".api_key" | translate;

<p-dialog
    [header]="'set_int_connect_apiKey_heading' | translate: { integrationName: integrationName }"
    [(visible)]="showAddApiKeyDialog"
    [modal]="true"
    [draggable]="false"
    [resizable]="false"
    [style]="{ width: '50rem', maxWidth: '90vw' }"
>
    <p>{{ "set_int_api_key_modal_text" | translate: { integrationName: integrationName, apiKeyName } }}</p>

    @if (withEmail) {
        <div class="flex flex-grow-1 w-full gap-2 items-center mt-4 mb-2">
            <label for="akdInputEmail" class="font-semibold w-20 text-right">{{ "set_int_apikey_email_label" | translate }}</label>
            <div class="flex-1 max-w-175">
                <input pInputText id="akdInputEmail" type="email" [(ngModel)]="email" class="w-full" autocomplete="off" (ngModelChange)="validateInputs()" />
            </div>
        </div>
    }

    <div class="flex flex-grow-1 w-full gap-2 items-center mt-4 mb-4">
        <label for="akdInputApiKey" class="font-semibold w-20 text-right">{{ apiKeyName }}</label>
        <div class="flex-1 max-w-175">
            <p-password
                data-testid="integration-api-key-input"
                #akdInputApiKey
                [(ngModel)]="apiKey"
                [label]="apiKeyName"
                class="w-full"
                [feedback]="false"
                [toggleMask]="true"
                autocomplete="off"
                (ngModelChange)="validateInputs()"
            />
        </div>
    </div>

    <!-- TODO url -->
    @if (apiKeyPageUrl) {
        @let text = "set_int_api_key_modal_key_page_hint" | translate: { integrationName: integrationName, url: apiKeyPageUrl, apiKeyName };
        <p [innerHTML]="text | safe: 'html'"></p>
    } @else {
        <!-- TODO some text for integrations where we cannot link the page where the user can find the API key... -->
    }

    <ng-template pTemplate="footer">
        <p-button [label]="'button_cancel' | translate" text severity="secondary" (click)="closeDialog()"></p-button>
        <p-button
            data-testid="integration-api-key-submit"
            [label]="'set_int_connect_action' | translate"
            [disabled]="saveDisabled"
            (click)="saveApiKey()"
        ></p-button>
    </ng-template>
</p-dialog>
